module.exports = "query Favorites {\n  favorites\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Favorites.graphql
// module id = 2007
// module chunks = 1611